import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function ForgotPinDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="forgot-pin-dialog">
        <DialogHeader>
          <DialogTitle>Forgot your PIN?</DialogTitle>
          <DialogDescription className="pt-2 text-slate-600">
            PINs cannot be reset from this screen. Please contact your Director, Manager, or Back Office to have your PIN reset.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
